const API_URL = process.env.NODE_ENV === 'production' 
  ? process.env.BACKEND_URL || 'https://fhir.cloverhound.com'
  : 'https://chad-zomn-dev2.ngrok.io';

export default API_URL; 